export enum RevisionHistoryState {
  DATETIME = 'DATETIME',
  DATE = 'DATE',
}

export const RevisionHistoryDropdown = [
  { label: 'Date & Time', value: RevisionHistoryState.DATETIME },
  { label: 'Date', value: RevisionHistoryState.DATE },
] as const;

export type RevisionHistoryOption = (typeof RevisionHistoryDropdown)[number];

export type RevisionHistoryValue = RevisionHistoryOption['value'];
